'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    notificationRecipient: 'ORGANISATION_UNIT_CONTACT',
    deliveryChannels: [],
    notifyUsersInHierarchyOnly: false
};
//# sourceMappingURL=validationNotificationTemplate.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/validationNotificationTemplate.js
// module id = 384
// module chunks = 0